import { IconX } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import QRCodeStyling from 'qr-code-styling';
import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { imageUploadApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import "./CreateQR.css";
import { ensureHttpPrefix } from '../../../utils/url.utils';

const CreateQr = ({ buttonComponent, callback }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => { ref.current = null; setShow(false) };
    const handleShow = () => setShow(true);

    const navigate = useNavigate();


    const [fileExt, setFileExt] = useState("svg");
    const ref = useRef(null);

    const [options, setOptions] = useState({
        width: 200,
        height: 200,
        type: 'svg',
        data: '',
        image: '',
        margin: 10,
        qrOptions: {
            typeNumber: 0,
            mode: 'Byte',
            errorCorrectionLevel: 'Q'
        },
        imageOptions: {
            hideBackgroundDots: true,
            imageSize: 0.5,
            margin: 5,
            crossOrigin: 'anonymous',
        },
        dotsOptions: {
            color: '#000',
            type: 'rounded'
        },
        backgroundOptions: {
            color: '#fff',
        },
        cornersSquareOptions: {
            color: '#222222',
            type: 'extra-rounded',
        },
        cornersDotOptions: {
            color: '#222222',
            type: 'dot',
        }
    });

    const [qrCode] = useState(new QRCodeStyling(options));
    const [customBackResp, setCustomBackResp] = useState(null);

    const checkCustomBackHalf = async (e) => {
        let postData = {
            "linkCode": e.target.value?.trim(),
        }
        if (e.target.value?.length >= 3) {
            let resp = await postApi(postData, urlApi.checkCustomBackHalf);
            setCustomBackResp(resp);
        } else if (e.target.value?.length == 0) {
            setCustomBackResp(null);
        }
    }

    useEffect(() => {
        if (ref.current) {
            qrCode.append(ref.current);
        }
    }, [qrCode, ref, show, options]);

    useEffect(() => {
        if (!qrCode) return;
        qrCode.update(options);
    }, [qrCode, options, show]);


    // const onLinkChange = (e) => {
    //     let local = { ...options };
    //     local.data = e.target.value;
    //     setOptions(local);
    // }

    const onExtensionChange = (event) => {
        setFileExt(event.target.value);
    };

    async function shortenUrl() {
        if (document.getElementById("link").value?.trim()) {
            let postData = {
                "link": ensureHttpPrefix(document.getElementById("link").value?.trim()),
            }
            if (document.getElementById("custom-back-half").value?.trim()) {
                postData.linkCode = document.getElementById("custom-back-half").value?.trim();
            }
            if (document.getElementById("name").value?.trim()) {
                postData.name = document.getElementById("name").value?.trim();
            }
            let resp = await postApi(postData, urlApi.shortenLinkForQr);
            if (resp.responseCode === 200) {
                return resp
            } else {
                toast.error(resp.message);
                loadingHide();
                return;
            }
        } else {
            toast.error("Please enter a link");
            loadingHide();
            return;
        }
    }

    async function uploadQr(data) {
        const formData = new FormData();
        const blob = new Blob([data], { type: 'image/png' });
        formData.append('name', 'image/png');
        formData.append('image', data);

        let resp = await imageUploadApi(formData, urlApi.imageUploadApi + "?folder=qr");

        if (resp.responseCode === 200) {
            return resp;
        } else {
            toast.error(resp.message);
            return;
        }
    }

    const onDownloadClick = async () => {
        loadingShow();
        if (!qrCode) return;
        // qrCode.download({
        //     extension: fileExt
        // });

        let shortLink = await shortenUrl();
        let local = { ...options };
        local.data = shortLink?.data;
        setOptions(local);

        if (shortLink?.responseCode === 200) {

            setTimeout(() => {
                qrCode.getRawData().then(async (data) => {
                    let imageLink = await uploadQr(data);
                    let postData = {
                        qrLink: imageLink.data,
                        shortLink: shortLink.data
                    }
                    let resp = await postApi(postData, urlApi.createQr);
                    loadingHide();
                    if (resp.responseCode === 200) {
                        toast.success(resp.message);
                        if (callback) {
                            callback();
                        }
                        handleClose();
                    } else {
                        toast.error(resp.message);
                    }
                });
            }, 1000);


        }

    };

    async function onCreateAndCustomizationClick() {
        loadingShow();
        if (document.getElementById("link").value?.trim()) {
            let postData = {
                "link": ensureHttpPrefix(document.getElementById("link").value?.trim()),
            }
            if (document.getElementById("custom-back-half").value?.trim()) {
                postData.linkCode = document.getElementById("custom-back-half").value?.trim();
            }
            if (document.getElementById("name").value?.trim()) {
                postData.name = document.getElementById("name").value?.trim();
            }
            let resp = await postApi(postData, urlApi.shortenLinkForQr);
            loadingHide();
            if (resp.responseCode === 200) {
                navigate("/qr-codes-customize", { state: resp });
            } else {
                toast.error(resp.message);
                return;
            }
        } else {
            toast.error("Please enter a link");
            loadingHide();
            return;
        }
    }


    return (
        <>
            <div className="cursor-pointer" onClick={handleShow}>
                {buttonComponent}
            </div>
            <Modal show={show} onHide={handleClose} size='xl' backdrop='static'>
                <Modal.Body className='rounded-xl p-0'>
                    <div className="flex justify-between items-center pt-3 px-4">
                        <p className="text-md font-semibold">Create Code</p>
                        <button onClick={handleClose}> <IconX /></button>
                    </div>
                    <hr className='my-2' />
                    <div className='px-5 py-2'>
                        <div className='mb-3'>
                            <label htmlFor="link" className='text-sm font-semibold mb-1'>Destination</label>
                            <input type='text' id='link' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Enter your long URL here...' />
                        </div>
                        <div className='mb-4'>
                            <label htmlFor="" className='text-sm font-semibold mb-1'>Title (Optional)</label>
                            <input type='text' id='name' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Enter link title...' />
                        </div>

                        <p className='text-[20px] font-medium'>Short Link</p>

                        <div className="flex flex-wrap md:flex-nowrap">
                            <div className='mb-3 w-full md:w-[50%] px-2'>
                                <label htmlFor="" className='text-sm font-semibold mb-1'>Domain</label>
                                <select className='px-3 py-2 rounded-md border-2 text-sm w-full'>
                                    <option value="" selected disabled>advy.me</option>
                                </select>
                            </div>
                            <div className='mb-3 w-full md:w-[50%] px-2'>
                                <label htmlFor="" className='text-sm font-semibold mb-1'>Custom back-half (optional)</label>
                                <input type='text' id='custom-back-half' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Minimum 3 Character'
                                    onChange={_debounce((e) => checkCustomBackHalf(e), 300)} />
                                <p className="mb-0 text-xs text-gray-500">
                                    *Minimum 3 characters, including alphanumeric characters and special characters (only '-' , '_').
                                </p>
                                {
                                    customBackResp &&
                                    <div className={`text-xs ps-1 ${customBackResp?.responseCode == 200 ? "text-green-700" : 'text-red-700'}`}>{customBackResp?.message}</div>
                                }
                            </div>
                        </div>
                    </div>
                    <hr className='my-3' />
                    <div className='flex gap-3 flex-wrap px-4 py-2'>
                        <button className='modal-cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn ms-auto' onClick={() => onDownloadClick()}>Create QR</button>
                        <button className='primary-btn' onClick={() => onCreateAndCustomizationClick()}>Customize & Create</button>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default CreateQr